module.exports = __webpack_public_path__ + "static/android_1_EN-1259fb88ec04120c0544bea9da70b876.jpg";